import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useLicensorContext() {
  const { licensors } = useContext<GlobalContextType>(GlobalContext);
  return licensors;
}
